import './App.css';
import Cauldron from './heiscoming/cauldron';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import Homepage from './menu/homepage';
import HeIsComingHomepage from './heiscoming/he-is-coming-homepage';
import Compendium from './heiscoming/compendium';

function getBackLink(pathname: string) {
  if (pathname.startsWith('/heiscoming/cauldron') || pathname.startsWith('/heiscoming/compendium')) {
    return '/heiscoming';
  }
  return '/';
}
function App() {
  const location = useLocation();

  return (
    <div className="app">

      <div className="app-content">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/heiscoming" element={<HeIsComingHomepage />} />
          <Route path="/heiscoming/cauldron" element={<Cauldron />} />
          <Route path="/heiscoming/compendium" element={<Compendium />} />
        </Routes>
      </div>
      <div className="app-footer">
        {location.pathname !== '/' && (
          <nav>
            <Link className="app-footer-back-link" to={getBackLink(location.pathname)} relative="path">Return to last page</Link>
          </nav>
        )}
        <div className="app-footer-text">
          {location.pathname !== '/' && (
            <span>He Is Coming Fanpage - </span>
          )}
          <a href='https://steamcommunity.com/id/MebboGaming' target="_blank" rel="noreferrer">I made this :)</a>
          {location.pathname !== '/' && (
            <span> - Last updated for Game Patch: 16 Version: 0.9.45</span>
          )}
        </div>
      </div>
    </div>
  );
};
export default App;
